import { Component, Input, OnInit } from '@angular/core';
import { NotificationService } from './notification.service';
import { Notification } from './notification.model';

@Component({
    selector: 'app-notification',
    templateUrl: './notification.component.html',
    styleUrls: ['./notification.component.scss'],
    standalone: false,
})
export class NotificationComponent implements OnInit {
    @Input() public notificationCount: number;
    @Input() public closeAfter: number;
    protected notifications: Notification[];

    public constructor(public notificationService: NotificationService) {}

    public ngOnInit(): void {
        this.notificationService.configure(this.notificationCount, this.closeAfter);
    }

    public removeNotification(notification: Notification): void {
        this.notificationService.removeNotification(notification);
    }
}
